var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecsAddit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.5C25.5228 22.5 30 18.0228 30 12.5C30 6.97715 25.5228 2.5 20 2.5C14.4772 2.5 10 6.97715 10 12.5C10 18.0228 14.4772 22.5 20 22.5Z",
    stroke: "#212529",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2227 17.7983L3.75 31.2499L10.5359 31.2171C10.7534 31.216 10.9673 31.2716 11.1567 31.3785C11.346 31.4854 11.5042 31.6398 11.6156 31.8265L15 37.4999L21.9008 22.3187",
    stroke: "#212529",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6359 17.5L36.25 31.25L29.4641 31.2172C29.2466 31.2161 29.0327 31.2717 28.8433 31.3786C28.654 31.4855 28.4958 31.6399 28.3844 31.8266L25 37.5L20 26.5",
    stroke: "#212529",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5C22.7614 17.5 25 15.2614 25 12.5C25 9.73858 22.7614 7.5 20 7.5C17.2386 7.5 15 9.73858 15 12.5C15 15.2614 17.2386 17.5 20 17.5Z",
    stroke: "#212529",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecsAddit);
export default __webpack_public_path__ + "static/media/recs__addit.5dd4cb9f323ac9c5bf90c8c0dde45c64.svg";
export { ForwardRef as ReactComponent };